import { atom, createStore, useAtomValue } from 'jotai'
import type { EnvType } from '~/env'

export const env$ = atom<EnvType>({} as EnvType)

export function useEnv() {
  return useAtomValue(env$)
}

if (import.meta.vitest) {
  const { describe, test, expect } = import.meta.vitest
  describe('env$ destructuring', () => {
    test('initial empty env before initialized', () => {
      const store = createStore()
      const env = store.get(env$)
      // https://github.com/ikyucom/macaron-frontend/issues/2424
      // env を Context から Jotai 管理に移したときに object destructuring でエラーが出ていた
      const { RESTAURANT_IKYU_ORIGIN: origin } = env
      expect(origin).toBeUndefined()
    })

    test('after initialized', () => {
      const store = createStore()
      store.set(env$, { RESTAURANT_IKYU_ORIGIN: 'https://restaurant.ikyu.com' } as EnvType)
      const env = store.get(env$)
      const { RESTAURANT_IKYU_ORIGIN: origin } = env
      expect(origin).toBe('https://restaurant.ikyu.com')
    })
  })
}
